import { useApiQuery } from '@/hooks/use-api-query';
import { qk } from '@/lib/query/keys';
import type { DeliveryLog } from '@/types/delivery';

export interface DeliveriesListResponse {
  logs: DeliveryLog[];
  nextCursor: string | null;
}

// The initial REST snapshot for the Deliveries panel. Live updates arrive via
// the SSE stream (use-deliveries-stream) and are merged on top by the panel —
// they are deliberately NOT modeled as Query state.
export function useDeliveriesList(
  wsId: string | undefined,
  scope: string,
  sessionScoped: boolean,
) {
  return useApiQuery<DeliveriesListResponse>(
    qk.workspace(wsId ?? '', 'deliveries', scope),
    `/deliveries?scope=${encodeURIComponent(scope)}`,
    { enabled: !!wsId && sessionScoped },
  );
}
